import request from '@/utils/request'
/// 테스트를 위해 api를 빼고 진행하였음 옮길 시 api 넣고 jwt 토큰 검사하게끔 바람.


export function getRptSHBudgetManage(params){
  // html 이미지 출력 문제로 보류
  // let responseType = params.type !== "html" ? "blob" : "stream"
  let responseType = "blob"
  return request({
    url:'/api/getRptSHBudgetManage',
    method:'POST',
    meta:{apiVersion:'1.0.0'},
    headers:{ 'Content-Type': 'application/json;charset=utf8' },
    data : params,
    responseType: responseType
  })
}